import React from "react";

const RECT_RB_COLORS: Record<string, string> = {
  NC: "#e53935",
  NP: "#fb8c00",
  C: "#43a047",
  NA: "#757575",
  "NC+NP": "#8e24aa",
};

const RectRbBadge = ({ value }: { value: string }) => (
  <span
    style={{
      backgroundColor: RECT_RB_COLORS[value] || "#607d8b",
      color: "#fff",
      borderRadius: "4px",
      padding: "3px 10px",
      fontWeight: 700,
      fontSize: "11px",
      display: "inline-block",
      minWidth: 36,
      textAlign: "center",
      letterSpacing: "0.3px",
    }}
  >
    {value}
  </span>
);

const RemarkBadge = ({ value }: { value: string }) => {
  const isNotFiled = value === "Not Filed";
  return (
    <span
      style={{
        backgroundColor: isNotFiled ? "#26c6da" : "#66bb6a",
        color: "#fff",
        borderRadius: "20px",
        padding: "4px 14px",
        fontSize: "11px",
        fontWeight: 600,
        display: "inline-block",
        whiteSpace: "nowrap",
      }}
    >
      {value}
    </span>
  );
};

export const LINEITEM_COLOUMNS = [
  {
    Header: "S.No.",
    id: "row_index",
    width: 60,
    Cell: ({ row }: any) => (
      <div style={{ justifyContent: "center" }}>{row.index + 1}</div>
    ),
  },

  {
    Header: "Site",
    accessor: "location_name",
    width: 180,
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: "Location",
    accessor: "city_name",
    width: 100,
  },
  {
    Header: "Vendor Name",
    accessor: "vendor_name",
    width: 210,
  },
  {
    Header: "Category",
    accessor: "category",
    width: 90,
  },

  {
    Header: "Title",
    accessor: "compliance_activity",
    width: 250,
    Cell: ({ value }: any) => <span style={{ fontWeight: 700 }}>{value}</span>,
  },

  {
    Header: "Status",
    accessor: "audit_status",
    width: 150,
    Cell: ({ value }: any) => <RectRbBadge value={value} />,
  },
 
  {
    Header: "Observation/Comment",
    accessor: "audit_abservation_comment",
    width: 250,
    Cell: ({ value }: any) => (
      <span style={{ color: "#555", fontSize: 12 }}>{value}</span>
    ),
  },
   {
    Header: "Recommendation",
    accessor: "recommendation",
    width: 120,
  },
  {
    Header: "Final Date",
    accessor: "final_date",
    width: 150,
  },
  {
    Header: "Rectification Filed Date",
    accessor: "rect_filed_date",
    width: 160,
  },
];
